import React, { FC } from 'react'
import { getReadableTimeSince } from '../../../../__helpers/get-readable-time-since/get-readable-time-since'
import {
    StyledPublicationDate,
    StyledPublicationDateWrapper,
    StyledUpdateLabel,
} from './PublishedTime.styled'
import { isLiveEvent } from '../../../../__helpers/is-live-event'

interface NightlyPublishedTimeProps {
    shouldDisplay?: boolean
    publicationDate?: string
    isUpdatedTimestamp?: boolean
    /**
     * To determine the hierarchy for the readable time
     * For article, display based on the actual updated time
     * For live event, display based on publish time of the latest event post
     */
    publicationKind?: string
}

export const PublishedTime: FC<NightlyPublishedTimeProps> = ({
    shouldDisplay = true,
    publicationDate,
    isUpdatedTimestamp = false,
    publicationKind,
}) => {
    if (!shouldDisplay || !publicationDate) return null

    const publicationDateMessage = getReadableTimeSince({
        publicationDate,
        comparisonDate: new Date().toISOString(),
        hierarchy: isLiveEvent(publicationKind) ? 'eventPost' : 'default',
    })

    return (
        <StyledPublicationDateWrapper>
            {isUpdatedTimestamp && (
                <StyledUpdateLabel>Updated</StyledUpdateLabel>
            )}
            <StyledPublicationDate dateTime={publicationDate}>
                {publicationDateMessage}
            </StyledPublicationDate>
        </StyledPublicationDateWrapper>
    )
}
